// Floating copilot launcher — a pill centered at the bottom of the canvas with
// a REAL text input: type a request and press Enter to open the docked sidebar
// chat with that message already sent. The caret button (or Enter on an empty
// input) just opens the sidebar. All chat logic lives in WorkflowCopilotPopup;
// this is purely the entry point.

var React = require('react');
var { createElement: h, useState } = React;
require('./WorkflowCopilotLauncher.css');

function SparkIcon() {
  return h('svg', {
    width: 16, height: 16, viewBox: '0 0 24 24',
    fill: 'none', stroke: 'currentColor', strokeWidth: 2,
    strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': 'true'
  },
    h('path', { d: 'M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z' }),
    h('path', { d: 'M19 15l.7 1.9L21.5 17.5l-1.8.6L19 20l-.6-1.9L16.5 17.5l1.9-.6L19 15z' })
  );
}

function WorkflowCopilotLauncher(props) {
  var onOpen = props.onOpen || function() {}; // (initialText) => void
  var [text, setText] = useState('');

  function open() {
    var t = text.trim();
    setText('');
    onOpen(t);
  }

  function stop(e) { e.stopPropagation(); }

  return h('div', {
    className: 'copilot-launcher',
    onMouseDown: stop, onTouchStart: stop, onClick: stop, onWheel: stop
  },
    h('span', { className: 'copilot-launcher-icon', 'aria-hidden': 'true' }, SparkIcon()),
    h('input', {
      className: 'copilot-launcher-input',
      type: 'text',
      placeholder: 'Ask Copilot to explore or edit your workflow…',
      value: text,
      onChange: function(e) { setText(e.target.value); },
      onKeyDown: function(e) {
        if (e.key === 'Enter') { e.preventDefault(); open(); }
      }
    }),
    h('button', {
      type: 'button',
      className: 'copilot-launcher-go',
      title: 'Open Workflow Copilot',
      onClick: open
    },
      h('svg', { width: 13, height: 13, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.4, strokeLinecap: 'round', strokeLinejoin: 'round' },
        h('path', { d: 'M18 15l-6-6-6 6' })
      )
    )
  );
}

module.exports = WorkflowCopilotLauncher;
